'use client'

import React, { createContext, useContext, ReactNode } from 'react'
import { useAllNavigationData, type NavigationContextData } from '@/lib/hooks/useNavigationData'

// Create context with default values
const NavigationContext = createContext<NavigationContextData>({
  availableGameweeks: [],
  tokenBalances: null,
  gameweekInfo: null,
  notifications: null,
  userRank: null,
  liveMatches: [],
  userProfile: null,
  isLoading: true,
  error: null
})

// Navigation provider props
interface NavigationProviderProps {
  children: ReactNode
}

// Internal data provider component (used inside QueryClientProvider)
function NavigationDataProvider({ children }: NavigationProviderProps) {
  const navigationData = useAllNavigationData()

  return <NavigationContext.Provider value={navigationData}>{children}</NavigationContext.Provider>
}

// Navigation provider component
export function NavigationProvider({ children }: NavigationProviderProps) {
  return <NavigationDataProvider>{children}</NavigationDataProvider>
}

// Hook to use navigation context
export function useNavigationData() {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigationData must be used within a NavigationProvider')
  }
  return context
}
